import { useEffect } from "react";

export const useEscapeByOverlays = (id?:string, callback?:()=>void) => {
    const onEscape = (event: KeyboardEvent) => {
    if (event.key == "Escape") {
      event.preventDefault();
      event.stopPropagation();

      const modalRoot = document.getElementById('modal-root');
      if (!modalRoot||!modalRoot.children?.length) {
        return
      }

      let maxIndexElement = null;
      let maxZIndex = 0;
      for (let index = 0; index < modalRoot.children.length; index++) {
        const element = modalRoot.children[index];
        const zIndex = parseInt(getComputedStyle(element).getPropertyValue('z-index'));
        if (zIndex > maxZIndex&&element.children.length) {
          maxZIndex = zIndex;
          maxIndexElement = element as HTMLElement;
        }
      }

      if (maxIndexElement) {
        maxIndexElement?.click?.();

        if (maxIndexElement.id === id) {
          callback?.();
        }
      }
    }
  }

  useEffect(() => {
    document.addEventListener('keydown', onEscape);

    return () => document.removeEventListener('keydown', onEscape);
    //eslint-disable-next-line
  }, []);
}